import { render, staticRenderFns } from "./ItemDetailModal.vue?vue&type=template&id=37de03bc"
import script from "./ItemDetailModal.vue?vue&type=script&lang=js"
export * from "./ItemDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailModal.vue?vue&type=style&index=0&id=37de03bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports